// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import pencilLineIcon from "@/assets/icons/pencil-line.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type PencilLineIconProps = Omit<IconProps, "name">;

export function PencilLineIcon(props: PencilLineIconProps): React.ReactNode {
  return <Icon name={pencilLineIcon} {...props} />;
}
